




























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import { BIcon, BIconUpload, BButton, BModal } from "bootstrap-vue";
import Footer from "@/components/Footer.vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
@Component({
  components: {
    Header,
    Menu,
    BIcon,
    BIconUpload,
    BButton,
    BModal,
    Footer,
    NextPrevBtn
  }
})
export default class GeneralCultureSignificance extends Vue {
  protected nxtprevGeneralCultureSignificance = {
    BoolPrev: false,
    BoolNext: true,
    PrevImage: " ",
    NextImage: "/thumbnail4.png",
    PrevLink: " ",
    NextLink: "/CultureGenerale/Aller_Plus_Loin"
  };
}
